module.exports = __webpack_public_path__ + "img/keys_and_certificates.93a4fe76.png";